var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomRow',[_c('v-card',{staticClass:"mt-5 text-center cusPadding",attrs:{"height":"574"}},[_c('SendEmailForm',{attrs:{"email":_vm.email}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }